<button class="{{dataClasses}}" (click)="createRfq()">
  <svg class="icon" aria-labelledby="quotation-label" focusable="false">
    <title id="quotation-label">Request for Quotation</title>
    <use xlink:href="/assets/images/sprite.svg#quotation"></use>
  </svg>
  @if (btnText) {
    <span translate class="app-link">{{btnText}}</span>
  }
</button>
